"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIFileButton = _interopRequireDefault(require("UIComponents/button/UIFileButton"));

var _DropBoxButton = _interopRequireDefault(require("./DropBoxButton"));

var _GoogleDriveButton = _interopRequireDefault(require("./GoogleDriveButton"));

var _CanvaButton = _interopRequireDefault(require("FileManagerCore/components/CanvaButton"));

var _Files = require("../../actions/Files");

var _Constants = require("../../Constants");

var _Actions = require("../../actions/Actions");

var _Canva = require("FileManagerCore/actions/Canva");

var _Dropbox = require("FileManagerCore/actions/Dropbox");

var _GoogleDrive = require("FileManagerCore/actions/GoogleDrive");

var _Canva2 = require("FileManagerCore/constants/Canva");

var _Limits = require("FileManagerCore/selectors/Limits");

var _Panel = require("../../selectors/Panel");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _network = require("../../utils/network");

var _hubLVideo = require("../../utils/hubLVideo");

var _Auth = require("FileManagerCore/selectors/Auth");

var _Permissions = require("FileManagerCore/selectors/Permissions");

var _ScopedFeatureTooltip = _interopRequireDefault(require("FileManagerCore/components/permissions/ScopedFeatureTooltip"));

var _CanvaCreateDisabledButton = _interopRequireDefault(require("FileManagerCore/components/CanvaCreateDisabledButton"));

var _Configuration = require("../../selectors/Configuration");

var _FileAccess = require("../../enums/FileAccess");

function getVideoLimitI18nKey(suffix) {
  return "FileManagerLib.videoLimit.uploadVideosDisabledTooltip." + suffix;
}

var Footer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Footer, _Component);

  function Footer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Footer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Footer).call(this, props));
    _this.state = {
      dropdownOpen: false
    };
    _this.handleUpload = _this.handleUpload.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleFromUrl = _this.handleFromUrl.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOpenChange = _this.handleOpenChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleUploadClick = _this.handleUploadClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCanvaImport = _this.handleCanvaImport.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDropboxImport = _this.handleDropboxImport.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleGoogleDriveImport = _this.handleGoogleDriveImport.bind((0, _assertThisInitialized2.default)(_this));

    if (props.dropdownClassName) {
      console.warn("Warning: Usage of the prop `dropdownClassName` should NOT be used for styling purposes. You can ignore this if you're using the className for a different purpose like namespacing.");
    }

    return _this;
  }

  (0, _createClass2.default)(Footer, [{
    key: "getButtonText",
    value: function getButtonText() {
      var type = this.props.type;

      switch (type) {
        case _Constants.DrawerTypes.IMAGE:
          return _I18n.default.text('FileManagerLib.actions.addImage');

        case _Constants.DrawerTypes.VIDEO:
        case _Constants.DrawerTypes.HUBL_VIDEO:
          return _I18n.default.text('FileManagerLib.actions.addVideo');

        case _Constants.DrawerTypes.DOCUMENT:
          return _I18n.default.text('FileManagerLib.actions.addDocument');

        default:
          return _I18n.default.text('FileManagerLib.actions.addFile');
      }
    }
  }, {
    key: "getAcceptedFileInputs",
    value: function getAcceptedFileInputs() {
      var type = this.props.type;

      switch (type) {
        case _Constants.DrawerTypes.IMAGE:
          return ['image/*'];

        case _Constants.DrawerTypes.VIDEO:
        case _Constants.DrawerTypes.HUBL_VIDEO:
          return ['video/*'];

        case _Constants.DrawerTypes.DOCUMENT:
          return _Constants.DrawerTypesToExtensions.get(_Constants.DrawerTypes.DOCUMENT).map(function (item) {
            return "." + item;
          }).toArray();

        default:
          return [];
      }
    }
  }, {
    key: "handleCanvaImport",
    value: function handleCanvaImport(_ref) {
      var canvaDesignId = _ref.canvaDesignId,
          fileUrl = _ref.fileUrl,
          fileName = _ref.fileName;
      this.props.onAcquireFromCanva({
        canvaDesignId: canvaDesignId,
        fileUrl: fileUrl,
        fileName: fileName,
        folder: this.props.selectedFolder,
        uploadedFileAccess: this.props.uploadedFileAccess
      });
    }
  }, {
    key: "handleDropboxImport",
    value: function handleDropboxImport(file) {
      var _this$props = this.props,
          onAcquireFromDropbox = _this$props.onAcquireFromDropbox,
          selectedFolder = _this$props.selectedFolder,
          uploadedFileAccess = _this$props.uploadedFileAccess;
      onAcquireFromDropbox(file, selectedFolder, uploadedFileAccess);
    }
  }, {
    key: "handleGoogleDriveImport",
    value: function handleGoogleDriveImport(file) {
      var _this$props2 = this.props,
          onAcquireFromDrive = _this$props2.onAcquireFromDrive,
          selectedFolder = _this$props2.selectedFolder,
          uploadedFileAccess = _this$props2.uploadedFileAccess;
      onAcquireFromDrive(file, selectedFolder, uploadedFileAccess);
    }
  }, {
    key: "handleOpenChange",
    value: function handleOpenChange(event) {
      this.setState({
        dropdownOpen: event.target.value
      });
    }
  }, {
    key: "handleUpload",
    value: function handleUpload(event) {
      var _this$props3 = this.props,
          selectedFolder = _this$props3.selectedFolder,
          onUploadFiles = _this$props3.onUploadFiles,
          type = _this$props3.type,
          activePanel = _this$props3.activePanel,
          onSetPanel = _this$props3.onSetPanel;
      var files = event.target.files;

      if (!files || files.length === 0) {
        return;
      }

      onUploadFiles(files, selectedFolder, type);

      if (activePanel === _Constants.Panels.FROM_URL || activePanel === _Constants.Panels.SEARCH) {
        onSetPanel(_Constants.Panels.BROWSE);
      }
    }
  }, {
    key: "handleUploadClick",
    value: function handleUploadClick() {
      this._file.click();
    }
  }, {
    key: "handleFromUrl",
    value: function handleFromUrl() {
      var _this$props4 = this.props,
          onSetPanel = _this$props4.onSetPanel,
          isUngatedForBulkImageImport = _this$props4.isUngatedForBulkImageImport;

      if (isUngatedForBulkImageImport) {
        onSetPanel(_Constants.Panels.BULK_IMPORT_FROM_URL);
      } else {
        onSetPanel(_Constants.Panels.FROM_URL);
      }
    }
  }, {
    key: "shouldRenderCanvaButton",
    value: function shouldRenderCanvaButton() {
      var _this$props5 = this.props,
          type = _this$props5.type,
          hasCanvaIntegrationScope = _this$props5.hasCanvaIntegrationScope,
          isUngatedForCanva = _this$props5.isUngatedForCanva,
          isCanvaEnabled = _this$props5.isCanvaEnabled;
      return hasCanvaIntegrationScope && isUngatedForCanva && isCanvaEnabled && !(0, _hubLVideo.isVideoDrawerType)(type);
    }
  }, {
    key: "renderReadOnlyUploadButton",
    value: function renderReadOnlyUploadButton() {
      return _react.default.createElement(_ScopedFeatureTooltip.default, null, _react.default.createElement(_UIButton.default, {
        buttonUse: "tertiary-light",
        "data-test-id": "drawer-upload-button-disabled",
        disabled: true
      }, this.getButtonText()));
    }
  }, {
    key: "renderDropdown",
    value: function renderDropdown() {
      var _this2 = this;

      var dropdownOpen = this.state.dropdownOpen;
      var _this$props6 = this.props,
          type = _this$props6.type,
          dropdownClassName = _this$props6.dropdownClassName,
          isReadOnly = _this$props6.isReadOnly;

      if (isReadOnly) {
        return this.renderReadOnlyUploadButton();
      } else if ((0, _hubLVideo.isVideoDrawerType)(type)) {
        return this.renderUploadVideoButton();
      }

      return _react.default.createElement("div", {
        "data-test-id": "drawer-footer-upload"
      }, _react.default.createElement("input", {
        className: "hidden",
        ref: function ref(_ref2) {
          _this2._file = _ref2;
        },
        type: "file",
        accept: this.getAcceptedFileInputs(),
        multiple: true,
        onChange: this.handleUpload
      }), _react.default.createElement(_UIDropdown.default, {
        open: dropdownOpen,
        buttonUse: "tertiary-light",
        buttonText: this.getButtonText(),
        onOpenChange: this.handleOpenChange,
        dropdownClassName: dropdownClassName,
        "data-test-id": "drawer-upload-dropdown"
      }, _react.default.createElement(_UIList.default, null, _react.default.createElement(_UILink.default, {
        onClick: this.handleUploadClick
      }, _react.default.createElement(_UIIcon.default, {
        className: "m-right-2",
        name: "upload"
      }), _I18n.default.text('FileManagerCore.actions.uploadFiles')), type === _Constants.DrawerTypes.IMAGE && _react.default.createElement(_UILink.default, {
        onClick: this.handleFromUrl
      }, _react.default.createElement(_UIIcon.default, {
        className: "m-right-2",
        name: "link"
      }), _I18n.default.text('FileManagerLib.actions.addFromUrl')), _react.default.createElement(_DropBoxButton.default, {
        useMultiSelect: true,
        importFile: this.handleDropboxImport,
        type: type
      }), _react.default.createElement(_GoogleDriveButton.default, {
        useMultiSelect: true,
        importFile: this.handleGoogleDriveImport,
        type: type,
        googleDriveOrigin: this.props.googleDriveOrigin
      }))));
    }
  }, {
    key: "renderDisabledVideoButtonTooltip",
    value: function renderDisabledVideoButtonTooltip(button, limit) {
      return _react.default.createElement(_UITooltip.default, {
        placement: "top",
        title: _react.default.createElement(_FormattedReactMessage.default, {
          message: getVideoLimitI18nKey('message'),
          options: {
            limit: limit,
            filesLink: _react.default.createElement(_UILink.default, {
              href: (0, _network.getRedirectToFilesLocation)(),
              key: "link-to-files"
            }, _react.default.createElement(_FormattedMessage.default, {
              message: getVideoLimitI18nKey('filesLink')
            }))
          }
        })
      }, button);
    }
  }, {
    key: "renderUploadVideoButton",
    value: function renderUploadVideoButton() {
      var _this$props7 = this.props,
          videoLimit = _this$props7.videoLimit,
          hasExceededEmbeddableVideoLimit = _this$props7.hasExceededEmbeddableVideoLimit;

      var button = _react.default.createElement(_UIFileButton.default, {
        use: "tertiary-light",
        size: "small",
        disabled: hasExceededEmbeddableVideoLimit,
        accept: this.getAcceptedFileInputs(),
        multiple: true,
        onChange: this.handleUpload
      }, _I18n.default.text('FileManagerCore.actions.uploadVideos'));

      if (hasExceededEmbeddableVideoLimit) {
        return this.renderDisabledVideoButtonTooltip(button, videoLimit);
      }

      return button;
    }
  }, {
    key: "renderCanvaButton",
    value: function renderCanvaButton() {
      var _this$props8 = this.props,
          specificCanvaTemplates = _this$props8.specificCanvaTemplates,
          isReadOnly = _this$props8.isReadOnly;

      if (!this.shouldRenderCanvaButton()) {
        return null;
      }

      if (isReadOnly) {
        return _react.default.createElement(_CanvaCreateDisabledButton.default, null);
      }

      return _react.default.createElement(_CanvaButton.default, {
        specificCanvaTemplates: specificCanvaTemplates,
        handleCanvaImport: this.handleCanvaImport
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "flex-row"
      }, this.renderDropdown(), this.renderCanvaButton());
    }
  }]);
  return Footer;
}(_react.Component);

Footer.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(_Constants.DrawerTypes)).isRequired,
  selectedFolder: _propTypes.default.instanceOf(_immutable.Map),
  activePanel: _propTypes.default.oneOf(Object.keys(_Constants.Panels)).isRequired,
  onSetPanel: _propTypes.default.func.isRequired,
  onUploadFiles: _propTypes.default.func.isRequired,
  onAcquireFromCanva: _propTypes.default.func.isRequired,
  onAcquireFromDropbox: _propTypes.default.func.isRequired,
  onAcquireFromDrive: _propTypes.default.func.isRequired,
  hasCanvaIntegrationScope: _propTypes.default.bool.isRequired,
  isCanvaEnabled: _propTypes.default.bool.isRequired,
  isUngatedForCanva: _propTypes.default.bool.isRequired,
  isUngatedForBulkImageImport: _propTypes.default.bool.isRequired,
  hasExceededEmbeddableVideoLimit: _propTypes.default.bool.isRequired,
  videoLimit: _propTypes.default.number.isRequired,
  googleDriveOrigin: _propTypes.default.string,
  dropdownClassName: _propTypes.default.string,
  specificCanvaTemplates: _propTypes.default.arrayOf(_propTypes.default.oneOf(_Canva2.CANVA_TEMPLATES)),
  isReadOnly: _propTypes.default.bool.isRequired,
  uploadedFileAccess: _propTypes.default.oneOf(Object.keys(_FileAccess.DrawerFileAccess))
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedFolder: (0, _Panel.getSelectedFolderInPanel)(state),
    activePanel: (0, _Panel.getActivePanel)(state),
    hasCanvaIntegrationScope: (0, _Auth.getHasCanvaIntegrationScope)(state),
    isCanvaEnabled: (0, _Configuration.getIsCanvaEnabled)(state),
    isUngatedForCanva: (0, _Auth.getIsUngatedForCanva)(state),
    isUngatedForBulkImageImport: (0, _Auth.getIsUngatedForBulkImageImport)(state),
    videoLimit: (0, _Limits.getEmbeddableVideoLimit)(state),
    hasExceededEmbeddableVideoLimit: (0, _Limits.getHasUserExceededEmbeddableVideoLimit)(state),
    specificCanvaTemplates: (0, _Configuration.getSpecificCanvaTemplates)(state),
    isReadOnly: (0, _Permissions.getIsReadOnly)(state),
    uploadedFileAccess: (0, _Configuration.getUploadedFileAccess)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onUploadFiles: function onUploadFiles(files, folder, type) {
      var options = {
        type: type
      };

      if (folder && folder.get('id')) {
        options.folderId = folder.get('id');
      }

      dispatch((0, _Files.uploadFiles)(files, options));
      dispatch((0, _Actions.trackInteraction)('Manage Files', 'upload'));
    },
    onSetPanel: function onSetPanel(activePanel) {
      dispatch((0, _Actions.setPanel)({
        activePanel: activePanel
      }));
    },
    onAcquireFromCanva: function onAcquireFromCanva(_ref3) {
      var canvaDesignId = _ref3.canvaDesignId,
          fileUrl = _ref3.fileUrl,
          folder = _ref3.folder,
          fileName = _ref3.fileName,
          uploadedFileAccess = _ref3.uploadedFileAccess;
      dispatch((0, _Canva.acquireFileFromCanva)({
        canvaDesignId: canvaDesignId,
        fileUrl: fileUrl,
        folder: folder,
        fileName: fileName,
        uploadedFileAccess: uploadedFileAccess
      }));
    },
    onAcquireFromDropbox: function onAcquireFromDropbox(file, folder, uploadedFileAccess) {
      dispatch((0, _Dropbox.acquireFileFromDropbox)(file, folder, uploadedFileAccess));
    },
    onAcquireFromDrive: function onAcquireFromDrive(file, folder, uploadedFileAccess) {
      dispatch((0, _GoogleDrive.acquireFileFromDrive)(file, folder, uploadedFileAccess));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Footer);

exports.default = _default;
module.exports = exports.default;